"use strict";

var _toArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toArray");

var _defineProperty = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanObject = exports.getLinearizedKeys = exports.linearize = exports.nest = exports.deepMerge = exports.isObject = exports.isJoi = exports.compareWithArray = exports.compareObj = exports.sortByProp = exports.lower = exports.removePrefix = exports.hasProp = exports.isEmpty = exports.updateObject = exports.set = exports.get = exports.removeProps = exports.removeProp = exports.keepProps = exports.deserialize = exports.unique = exports.groupBy = exports.transpose = exports.distinct = void 0;

var string_1 = require("./string");

exports.distinct = function (arr) {
  return _toConsumableArray(new Set(arr));
};

exports.transpose = function (arr) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a) {
    return a;
  };
  var r = {};
  Object.keys(arr).map(function (idx) {
    return Object.keys(arr[idx]).map(function (d) {
      if (!r[d]) {
        r[d] = {};
      }

      r[d][idx] = fn(arr[idx][d]);
      return true;
    });
  });
  return r;
};

exports.groupBy = function (arr, key) {
  var callback = function callback(acc, v) {
    (acc[exports.get(key, v)] = acc[exports.get(key, v)] || []).push(v);
    return acc;
  };

  var r = {};
  return arr.reduce(callback, r);
};

exports.unique = function (arr, prop) {
  var temp = arr.map(function (obj) {
    return prop ? exports.get(prop, obj) : obj;
  });
  return arr.filter(function (obj, i) {
    return temp.indexOf(prop ? exports.get(prop, obj) : obj) == i;
  });
};

exports.deserialize = function (str) {
  return str.split(',').reduce(function (r, item) {
    var arr = item.split('=');

    if (arr.length === 2) {
      var _arr = _slicedToArray(arr, 2),
          key = _arr[0],
          value = _arr[1];

      return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, key, value));
    }

    return r;
  }, {});
};

exports.keepProps = function (obj, props) {
  if (!props || !Array.isArray(props)) return obj;
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return props.includes(key) ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value)) : acc;
  }, {});
};

exports.removeProp = function (obj, prop) {
  return Object.keys(obj).reduce(function (acc, key) {
    return key !== prop ? _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, obj[key])) : acc;
  }, {});
};

exports.removeProps = function (obj, props) {
  while (props.length > 0) {
    obj = exports.removeProp(obj, props.pop());
  }

  return obj;
};

exports.get = function (p, o) {
  return p.split(".").reduce(function (xs, x) {
    if (xs && (xs[x] || xs[x] === 0 || xs[x] === false)) return xs[x];else return null;
  }, o);
};

exports.set = function (name, value, obj) {
  var keyArray = name.split('.');
  var l = keyArray.length;
  var f = obj;
  keyArray.map(function (k, i) {
    if (i === l - 1) {
      f[k] = value;
    } else {
      if (!f[k]) {
        f[k] = {};
      }
    }

    f = f[k];
  });
  return obj;
};

exports.updateObject = function (form, newObj) {
  return exports.set(newObj.name, newObj.value, form);
};

exports.isEmpty = function (obj) {
  if (Array.isArray(obj)) return false;
  if (!obj) return true;

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }

  return true;
};

exports.hasProp = function (o, prop) {
  return !exports.isEmpty(o) && prop && prop in o;
};

exports.removePrefix = function (obj, prefix) {
  if (obj.data) return obj.data;
  return Object.keys(obj).reduce(function (a, key) {
    return _objectSpread(_objectSpread({}, a), {}, _defineProperty({}, key.replace(prefix, ""), obj[key]));
  }, {});
};

exports.lower = function (value) {
  if (typeof value === 'number') return value;

  if (value && value.length > 0) {
    return value.toLowerCase();
  }

  return '';
};

exports.sortByProp = function (arr) {
  var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
  var asc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!arr) return null;

  var compare = function compare(a, b) {
    var attrA = exports.lower(string_1.removeWhitespace(String(exports.get(attr, a))));
    var attrB = exports.lower(string_1.removeWhitespace(String(exports.get(attr, b))));
    var comparison = 0;
    if (attrA > attrB) comparison = 1;else comparison = -1;
    return asc ? comparison : comparison * -1;
  };

  return arr.sort(compare);
};

exports.compareObj = function (a, b, attr) {
  var valueA = exports.get(attr, a);
  var valueB = exports.get(attr, b);

  if (!valueA || !valueB) {
    return 0;
  }

  if (typeof valueA === 'string') {
    valueA = valueA.toLowerCase();
  }

  if (typeof valueB === 'string') {
    valueB = valueB.toLowerCase();
  }

  return valueA.localeCompare(valueB);
};

exports.compareWithArray = function (newRecord, oldRecords, isRecordFound) {
  var isDuplicate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (x) {
    return false;
  };
  var isNotNull = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (x) {
    return true;
  };
  var recordFound = oldRecords.find(function (x) {
    return isRecordFound(newRecord, x);
  });

  if (recordFound) {
    if (isDuplicate(recordFound, newRecord)) {
      return {
        edit: true,
        data: newRecord,
        id: recordFound.id
      };
    } else {
      return {
        duplicate: true,
        id: recordFound.id,
        message: 'the same figure was already found in the system',
        data: newRecord
      };
    }
  } else {
    if (isNotNull(newRecord)) {
      return {
        add: true,
        data: newRecord
      };
    } else {
      return {
        warning: true,
        message: 'not imported the value is non existent (null)',
        data: newRecord
      };
    }
  }
};

exports.isJoi = function (schema) {
  return schema.hasOwnProperty('$_root') || schema.hasOwnProperty('$_super');
};

exports.isObject = function (item) {
  if (!item) return false;
  if (exports.isJoi(item)) return false;else return typeof item === 'object' && !Array.isArray(item) && item !== null;
};

exports.deepMerge = function (target, source) {
  if (exports.isObject(target) && exports.isObject(source)) {
    Object.entries(source).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          sourceValue = _ref4[1];

      if (exports.isObject(sourceValue)) {
        if (!target[key]) {
          Object.assign(target, _defineProperty({}, key, {}));
        }

        var next = target[key];
        exports.deepMerge(next, sourceValue);
      } else {
        Object.assign(target, _defineProperty({}, key, sourceValue));
      }
    });
  }

  return target;
};

exports.nest = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (data === undefined || data === null) return null;

  if (props.length === 0) {
    if (!Array.isArray(data)) {
      data = Object.entries(data).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return {
          key: key,
          value: value
        };
      });
    }

    if (data.length === 0) return {};
    var nested = {};
    data.forEach(function (_ref7) {
      var key = _ref7.key,
          value = _ref7.value;
      var props = key.split('.');
      var obj = exports.nest(value, props);
      nested = exports.deepMerge(nested, obj);
    });
    return nested;
  } else {
    var value = data;

    var _props = _toArray(props),
        prop = _props[0],
        rest = _props.slice(1);

    if (rest.length === 0) {
      return _defineProperty({}, prop, value);
    }

    var result = exports.nest(value, _toConsumableArray(rest));
    return _defineProperty({}, prop, result);
  }
};

exports.linearize = function (obj) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var list = [];
  Object.entries(obj).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
        key = _ref11[0],
        value = _ref11[1];

    var next = [].concat(_toConsumableArray(keys), [key]);

    if (exports.isObject(value)) {
      var subList = exports.linearize(value, next);
      list = [].concat(_toConsumableArray(list), _toConsumableArray(subList));
    } else {
      list.push({
        key: next.join('.'),
        value: value
      });
    }
  });
  return list;
};

exports.getLinearizedKeys = function (o) {
  return Object.keys(o).map(function (key) {
    var value = o[key];

    if (value != null && typeof value == 'object') {
      var nestedKeys = exports.getLinearizedKeys(value);
      return nestedKeys.map(function (item) {
        return "".concat(key, ".").concat(item);
      });
    } else return key;
  }).flat();
};

exports.cleanObject = function (obj) {
  var removeNull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  for (var propName in obj) {
    if (removeNull && obj[propName] === null) {
      delete obj[propName];
    } else if (obj[propName] === undefined) {
      delete obj[propName];
    } else {
      if (typeof obj[propName] === 'object' && obj[propName] !== null) {
        exports.cleanObject(obj[propName], removeNull);
      }
    }
  }
};